<!-- Presentational component to display a single custom cart item. -->
<template>
	<div v-if="plan && item">
		<SwipeableToggle
			target-class="my-[10px] hover:bg-primary-50"
			:model-value="!item.isSoftDeleted"
			@update:model-value="$event ? $emit('undelete') : $emit('delete')"
		>
			<div
				class="flex w-full items-start gap-4 overflow-hidden"
				:class="{
					'is-soft-deleted': item.isSoftDeleted,
					'is-negative-price': itemIsIncluded,
				}"
			>
				<GiftIcon
					v-if="itemIsIncluded"
					class="text-accent-600 h-10 w-10 object-cover"
				/>

				<div class="flex flex-1 flex-col">
					<div
						class="text-sm font-bold"
						:class="{
							'text-accent-600!': isDiscount,
							'text-primary-700': !isDiscount,
						}"
					>
						{{ item.title }}
					</div>
					<div class="truncate text-sm text-slate-500">
						{{ item.shortDescription }}
					</div>
				</div>
				<PriceDetailsDisplay
					:price-details="priceDetails"
					:deleted="item.isSoftDeleted"
				/>
			</div>
		</SwipeableToggle>
	</div>
</template>

<script setup lang="ts">
import PriceDetailsDisplay from './PriceDetailsDisplay.vue'
import Plan from '@/classes/Plan'
import SwipeableToggle from '@/components/common/SwipeableToggle.vue'
import { type PricingDetails } from '@/mixins/merchandise'
import type { CustomCartItem } from '@/types'
import { GiftIcon } from '@heroicons/vue/24/solid'
import { type PropType, computed } from 'vue'

const props = defineProps({
	plan: Object as PropType<Plan>,
	item: Object as PropType<CustomCartItem>,
})

defineEmits(['delete', 'undelete'])

const isDiscount = computed(() => props.item?.price && props.item.price < 0)

const priceDetails = computed<PricingDetails | undefined>(() => {
	if (!props.item) return undefined

	return {
		price: props.item.price,
		originalPrice: props.item.price,
		guaranteed: props.item.guaranteed ? props.item.price : 0,
		nonGuaranteed: props.item.guaranteed ? 0 : props.item.price,
	}
})

const itemIsIncluded = computed(() => {
	if (!props.item) return false

	return props.item.price && props.item.price <= 0
})
</script>
